import { useTranslation } from 'react-i18next'

import { ApiViewerToolbar } from '~/portal/components/ApiViewerToolbar'
import { SyntaxRenderer } from '~/portal/components/SyntaxRenderer'
import { API_FILE_TYPES } from '~/portal/types/downloadApi'
import { CONTENT_TYPE } from '~/shared/types/content'

const a2aDownloadOptions = [
  { id: '1', name: API_FILE_TYPES.JSON },
  { id: '2', name: API_FILE_TYPES.YAML },
]

export const A2AViewer = ({
  tableOfContentsId,
  title,
  registryUrl,
  content,
  lastModifiedDate,
  providerContentSlug,
  shubUrl,
  showEditButtons,
  accentColor,
  fontName,
  isConsumerSide = true,
  downloadDisabled,
}: {
  tableOfContentsId?: string
  title?: string
  registryUrl?: string
  content?: object
  lastModifiedDate?: string
  providerContentSlug?: string
  shubUrl?: string
  showEditButtons?: boolean
  accentColor?: string
  fontName?: string
  isConsumerSide?: boolean
  downloadDisabled?: boolean
}) => {
  const { t } = useTranslation()

  const buildDownloadUrl = registryUrl
    ? (format: string) => `/services/api/a2a-download?url=${encodeURIComponent(registryUrl)}&filename=${encodeURIComponent(title ?? 'api')}&format=${format}`
    : undefined

  return (
    <div
      data-testid="a2a-markdown-container"
      id="top"
      className="flex flex-col"
      style={{ fontFamily: fontName }}
    >
      <ApiViewerToolbar
        testId="a2a-viewer-toolbar"
        downloadOptions={a2aDownloadOptions}
        buildDownloadUrl={buildDownloadUrl}
        optionLabelBuilder={option => t('components.ui.apiViewer.downloadApi.unresolvedFormat', { format: option.name })}
        providerContentSlug={providerContentSlug}
        shubUrl={shubUrl}
        showEditButtons={showEditButtons}
        accentColor={accentColor}
        downloadDisabled={downloadDisabled}
      />
      <div className="relative">
        <SyntaxRenderer
          key={tableOfContentsId}
          type={CONTENT_TYPE.A2A}
          content={content}
          title={title}
          lastModifiedDate={lastModifiedDate}
          providerContentSlug={providerContentSlug}
          isConsumerSide={isConsumerSide}
          useMarkdocRenderer={true}
        />
      </div>
    </div>
  )
}
